import React from "react";
import Sidebar from "../atoms/sidebar";
import Routes from "../../routes/routes";

export default function layout() {
  return (
    <div>
      <Sidebar />
      <nav className="navbar navbar-expand">
        <span className="navbar-brand">Details</span>
      </nav>
      <div className="container-fluid">
        <Routes />
      </div>
    </div>
  );
}
